import React from 'react';
import { Button } from '@/components/ui/button';
import { Phone } from 'lucide-react';

const Contact = () => {
    return (
        <section id="contact" className="py-16 lg:py-20">
            <div className="section-container">
                {/* Map */}
                <div className="rounded-2xl overflow-hidden shadow-lg mb-12">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d234458.03824615706!2d77.40818!3d23.3372704!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x397c6976e47edb19%3A0x29182263e8601bd9!2sDhakad%20Enterprises%20-%20Build%20Your%20Dream%20Home!5e0!3m2!1sen!2sin!4v1770781157314!5m2!1sen!2sin"
                        width="100%"
                        height="400"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Dhakad Enterprises Location"
                        className="grayscale hover:grayscale-0 transition-all duration-500"
                    ></iframe>
                </div>

                {/* CTA Section */}
                <div className="bg-card rounded-2xl p-8 lg:p-12 border border-border shadow-lg">
                    <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
                        <div>
                            <h2 className="font-display text-3xl sm:text-4xl font-bold gradient-text mb-3">
                                Have a Question?
                            </h2>
                            <p className="text-muted-foreground text-lg">
                                Call to us or leave your phone number, and we call you back
                            </p>
                        </div>
                        
                        <div className="flex flex-col sm:flex-row items-center gap-6">
                            <Button 
                                className="bg-primary hover:bg-primary-dark text-primary-foreground font-medium px-8 py-6 text-base"
                                onClick={() => window.open('tel:+917999436770')}
                            >
                                Call Us Now
                            </Button>
                            
                            <div className="text-center sm:text-left">
                                <p className="text-sm text-muted-foreground mb-1">We online 24/7</p>
                                <a 
                                    href="tel:+917999436770"
                                    className="text-2xl font-bold text-foreground hover:text-primary transition-colors flex items-center gap-2"
                                >
                                    <Phone className="w-5 h-5" />
                                    +917999436770
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;
